// 直播列表
import request from '@/utils/request'
let jdBaseUrl='/MetaWorks/api/digitalhuman/v1/jd/' //京东地址
let jdUserBaseUrl='/MetaWorks/api/user/v1/user/' //京东地址
// 获取京东授权登录地址---后端serverice服务
export function jd_getCodeUrl (data) {
  return request({
    url: jdBaseUrl+"getCodeUrl",
    method: 'get',
    data
  })
}
// 直播销售数据
export function jd_live_sales (params) {
  return request({
    url: jdBaseUrl+"jd_live_detail",
    method: 'get',
    params
  })
}
// 获取京东授权登录地址---后端user服务---吉祥说用这个20240425
export function jd_getAccessCodeUrl (data) {
  return request({
    url: jdUserBaseUrl+"getCodeUrl",
    method: 'get',
    data
  })
}
